/*! @azure/msal-react v2.0.12 2024-02-17 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-react";
const version = "2.0.12";

export { name, version };
//# sourceMappingURL=packageMetadata.js.map
